import { NgModule } from '@angular/core';
import { ErrorsModule } from '@fullyops/features/errors/errors.module';
import { WorkOrderCategoriesModule } from '@fullyops/features/work-order-categories/work-order-categories.module';
import { WorkOrderScopesModule } from './work-order-scopes/work-order-scopes.module';

@NgModule({
  imports: [ErrorsModule, WorkOrderCategoriesModule, WorkOrderScopesModule],
})
export class FeaturesModule {}
